import React from "react";
import {
  bodyWrapper,
  cardWrapper,
  descriptionWrapper,
  image,
  titleWrapper
} from "./BenefitCard.css";

type Props = {
  imageUrl: string;
  imageStyle?: string;
  title: string;
  description: string;
};

export const BenefitCard: React.FC<Props> = ({
  imageUrl,
  imageStyle,
  title,
  description
}) => {
  return (
    <div className={cardWrapper}>
      <div className={imageStyle}>
        <img src={imageUrl} alt={title} className={image} />
      </div>
      <div className={bodyWrapper}>
        <p className={titleWrapper}>{title}</p>
        <p className={descriptionWrapper}>{description}</p>
      </div>
    </div>
  );
};
